import { render } from "./callLogs.vue?vue&type=template&id=f90985ee&scoped=true"
import script from "./callLogs.vue?vue&type=script&lang=js"
export * from "./callLogs.vue?vue&type=script&lang=js"

import "./callLogs.vue?vue&type=style&index=0&id=f90985ee&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f90985ee"]])

export default __exports__